module.exports = __webpack_public_path__ + "static/img/MANUFACTURING.c3262c33.jpg";